import TeaserBlock from './TeaserBlock';

export default TeaserBlock;
